import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import PrintDoc from "./PrintDoc";

import { api } from "../../../config";
import { useReactToPrint } from "react-to-print";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetClientState, getClient } from "../../../store/client/action";
import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetProductVarianState, getProductVarian } from "../../../store/productVarian/action";
import { resetBranchState, getBranch } from "../../../store/branch/action";
import { resetTransferState, getTransfer as onGetTransfers, addNewTransfer as onAddNewTransfer, updateTransfer as onUpdateTransfer, deleteTransfer as onDeleteTransfer, getTransferLoading } from "../../../store/transfer/action";
import { resetProductInventoryState, getProductInventory as onGetProductInventories, addNewProductInventory as onAddNewProductInventory, updateProductInventory as onUpdateProductInventory, deleteProductInventory as onDeleteProductInventory, getProductInventoryLoading } from "../../../store/productInventory/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import logoDark from "../../../assets/images/logo-dark.png";
import logoLight from "../../../assets/images/logo-light.png";
import ModalInputFile from "../../../Components/ModalInputFile";
import defaultImg from "../../../assets/images/upload.png";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import lottie from "lottie-web";
import { defineElement } from "lord-icon-element";
import ExportDoc from "../../../Components/Common/ExportDoc";
import exportExcel from "../../../helpers/utils/exportExcel";
defineElement(lottie.loadAnimation);

const Transfer = () => {
  // const filerIdRef = useRef({
  //   branchId: 1,
  // });
  const [pageIdx, setPageIdx] = useState(0);
  const printRef = useRef(null);
  const [logo, setLogo] = useState(defaultImg);
  const [invDocImg, setInvDocImg] = useState([]);
  const [modalMedia, setModalMedia] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clients, clientLoading, transfers, transferAdded, isTransferCreated, isTransferSuccess, loading, error, isProductInventoryCreated, companies, companyLoading, branches, branchLoading, productVarians, productVarianLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    transferAdded: state.Transfer.transferAdded,
    transfers: state.Transfer.transfers,
    isTransferCreated: state.Transfer.isTransferCreated,
    isTransferSuccess: state.Transfer.isTransferSuccess,
    loading: state.Transfer.loading,
    isProductInventoryCreated: state.ProductInventory.isProductInventoryCreated,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    productVarians: state.ProductVarian.productVarians,
    productVarianLoading: state.ProductVarian.loading,
    error: state.Transfer.error,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
  }));

  const [transferList, setTransferList] = useState([]);
  const [transferDoc, setTransferDoc] = useState([]);
  const [transfer, setTransfer] = useState([]);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusTransfer, setStatusTransfer] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [productList, setProductList] = useState([]);
  const [transferDetailItem, setTransferDetailItem] = useState([]);

  const [isSearch, setIsSearch] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, [printRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;
      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = invDocImg.map((obj) => {
        if (obj.id === file.id) {
          return { id: file.id, filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setInvDocImg(newState);
    } else {
      const index = invDocImg.findIndex((fl) => fl.filename === file.filename);
      setInvDocImg((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  const handleSelectFile = (file) => {
    setInvDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    toggleMedia();
  };

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredTransfers = transfers;
      if (type !== "all") {
        filteredTransfers = transfers.filter((transfer) => transfer.transfer_status.name === type);
      }
      setTransferList(filteredTransfers);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };

  const handleGetProductVariant = (companyId) => {
    dispatch(resetProductVarianState());
    dispatch(getProductVarian({ companyId: companyId, type: "referral" }));
  };

  const handleGetBranch = (companyId) => {
    dispatch(resetBranchState());
    dispatch(getBranch({ companyId: companyId, status: 2 }));
  };

  useEffect(() => {
    if (isProductInventoryCreated) {
      dispatch(resetProductInventoryState());
      dispatch(resetTransferState());
      dispatch(onGetTransfers({ type: "Distribution", branchId: branchSelected?.value ?? "" }));
    }
  }, [dispatch, isProductInventoryCreated]);

  useEffect(() => {
    setTransfer(transferAdded);
  }, [transferAdded]);

  useEffect(() => {
    if (!isEmpty(transferAdded)) {
      setTransfer(transferAdded);
    }
  }, [transferAdded]);

  useEffect(() => {
    if (!isEmpty(transfers)) {
      let filteredTransfers = transfers;
      if (activeTypeTab !== "all") {
        filteredTransfers = transfers.filter((transfer) => transfer.transfer_status.name === activeTypeTab);
      }
      setTransferList(filteredTransfers.map((el) => ({ ...el, isChecked: false })));
      setInfo(transfers[transfers.length - 1]);
    }
    else
    {
      setTransferList([]);
    }
  }, [transfers]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "transaction_no",
        label: "Invoice No",
        isSelected: true,
        data: [],
      },
      {
        id: "transactionat",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "transfer_from",
        label: "Cabang Asal",
        isSelected: true,
        data: [],
      },
      {
        id: "transfer_to",
        label: "Cabang Tujuan",
        isSelected: true,
        data: [],
      },
      {
        id: "transfer_detail_accept",
        label: "Accept",
        isSelected: true,
        data: [],
      },
      {
        id: "transfer_detail_reject",
        label: "Reject",
        isSelected: true,
        data: [],
      },
      {
        id: "transfer_status",
        label: "Status",
        isSelected: true,
        data: [],
      },
    ];

    if (transferList.length > 0) {
      transferList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);

            if (doc) {
              if (doc.id === "transactionat" || doc.id === "dueat") {
                doc.data.push(handleValidDate(value));
              } else if (doc.id === "transfer_from" || doc.id === "transfer_to" || doc.id === "transfer_status") {
                doc.data.push(value.name);
              } else {
                doc.data.push(value);
              }
            } else {
              if (key === "transfer_detail") {
                const acceptDoc = dataDoc.find((d) => d.id === "transfer_detail_accept");
                const rejectDoc = dataDoc.find((d) => d.id === "transfer_detail_reject");

                let qtyAccept = 0;
                let qtyReject = 0;
                value.forEach((element) => {
                  qtyAccept += element.accepted ? parseFloat(element.accepted) : 0;
                  qtyReject += element.rejected ? parseFloat(element.rejected) : 0;
                });
                acceptDoc.data.push(qtyAccept);
                rejectDoc.data.push(qtyReject);
              }
            }
          });
        }
      });
    }

    setTransferDoc(dataDoc);
  }, [transferList]);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(productVarians)) {
      var productVarianData = [];
      var opt = [];
      productVarians.forEach((item, key) => {
        const varian_name = item.pvar_product.name;
        const id = item.id;
        const barcode = item.barcode;
        const sku = item.sku;
        const price = item.price;
        const brandId = item.brandId;
        const productId = item.productId;
        let option_name = "";
        item.pvar_options &&
          item.pvar_options.forEach((i, k) => {
            option_name += i.name + "/";
          });

        var obj = { label: varian_name + " " + option_name.slice(0, -1) + " - " + barcode, name: varian_name + " " + option_name.slice(0, -1), barcode: barcode, sku: sku, value: id, price: price, brandId: brandId, productId: productId };
        opt.push(obj);
      });
      var option = { options: opt };
      productVarianData.push(option);
      setProductList(productVarianData);
    }
  }, [productVarians]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setTransfer(null);
      setInvDocImg([]);
      setTransferDetailItem([]);
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setTransfer(null);
      setTransferDetailItem([]);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const handleInvoiceClick = (arg) => {
    const transfer = arg;
    let transferDetail = [];

    if (transfer.transfer_detail) {
      transfer.transfer_detail.forEach((element) => {
        transferDetail.push({
          detailId: element.id,
          item: { label: element.name, value: element.productVarianId, name: element.name, sku: element.sku, barcode: element.barcode, price: element.amount, brandId: element.brandId, productId: element.productId },
          amount: parseFloat(element.amount),
          quantity: parseFloat(element.quantity),
          total: parseFloat(element.amount_total),
          name: element.name,
          sku: element.sku,
          uom: element?.transfer_detail_product?.product_uom?.name,
          barcode: element.barcode,
          brandId: element.brandId,
          accepted: element.accepted ? parseFloat(element.accepted) : 0,
          rejected: element.rejected ? parseFloat(element.rejected) : 0,
        });
      });
      setTransferDetailItem(transferDetail);
    }

    setTransfer(transfer);
    let files = [];
    for (const f of transfer.transfer_file) {
      files.push({ filename: f.filename, originalname: f.originalname });
    }
    setInvDocImg(files);
    toggleDetail();
  };

  const handleTransferClick = useCallback(
    (arg) => {
      const transfer = arg;
      let transferDetail = [];

      if (transfer.transfer_detail) {
        transfer.transfer_detail.forEach((element) => {
          transferDetail.push({
            detailId: element.id,
            transferId: transfer.id,
            itemId: element.productVarianId,
            item: { label: element.name, value: element.productVarianId, name: element.name, sku: element.sku, barcode: element.barcode, price: element.amount, brandId: element.brandId, productId: element.productId },
            amount: parseFloat(element.amount),
            quantity: parseFloat(element.quantity),
            total: parseFloat(element.amount_total),
            name: element.name,
            sku: element.sku,
            uom: element?.transfer_detail_product?.product_uom?.name,
            barcode: element.barcode,
            brandId: element.brandId,
            accepted: element.accepted ? parseFloat(element.accepted) : parseFloat(element.quantity),
            rejected: element.rejected ? parseFloat(element.rejected) : 0,
          });
        });
        setTransferDetailItem(transferDetail);
      }

      let files = [];
      for (const f of transfer.transfer_file) {
        files.push({ filename: f.filename, originalname: f.originalname });
      }
      setInvDocImg(files);

      setTransfer({
        id: transfer.id,
        description: transfer.description,
        type: transfer.type && { label: transfer.type, value: transfer.type },
        branch: transfer.transfer_branch && { label: transfer.transfer_branch.name, value: transfer.transfer_branch.id },
        company: transfer.transfer_company && transfer.transfer_company.name && { label: transfer.transfer_company.name, value: transfer.transfer_company.id },
        client: transfer.transfer_client && transfer.transfer_client.name && { label: transfer.transfer_client.name, value: transfer.transfer_client.id },
        status: transfer.transfer_status && { label: transfer.transfer_status.name, value: transfer.transfer_status.id },
        clientId: transfer.clientId,
        branchId: transfer.toBranchId,
        toBranchId: transfer.toBranchId,
        fromBranchId: transfer.fromBranchId,
        companyId: transfer.companyId,
      });

      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  function currencyFormat(num) {
    return "Rp " + parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = transferList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setTransferList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        filterable: false,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = transferList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setTransferList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      handleInvoiceClick(data);
                    }}
                  >
                    <i className="ri-eye-line fs-15"></i>
                  </Button>
                  {data.statusId === 3 && (
                    <Button
                      color="soft-success"
                      className={userType === "admin" || userType === "client" ? "btn btn-sm btn-soft-success fs-12 me-0" : userRole && userRole.split(",").indexOf("createProductInventory") !== -1 ? "btn btn-sm btn-soft-success fs-12 me-0" : "btn btn-sm btn-soft-success fs-12 me-0 d-none"}
                      onClick={() => {
                        handleTransferClick(data);
                      }}
                    >
                      <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i> Accept
                    </Button>
                  )}
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Invoice No",
        accessor: "transaction_no",
        filterable: true,
        Cell: (cellProps) => (
          <Link
            to="#"
            className="fw-semibold"
            onClick={() => {
              let data = cellProps.row.original;
              handleInvoiceClick(data);
            }}
          >
            {cellProps.row.original.transaction_no}
          </Link>
        ),
      },
      {
        id: "Tanggal",
        Header: "Tanggal",
        accessor: "transactionat",
        filterable: false,
        Cell: (data) => {
          return handleValidDate(data.row.original.transactionat);
        },
      },
      {
        Header: "Cabang Asal",
        accessor: "transfer_from.name",
        filterable: true,
      },
      {
        Header: "Cabang Tujuan",
        accessor: "transfer_to.name",
        filterable: true,
      },
      {
        Header: "Accept",
        filterable: true,
        Cell: (data) => {
          let qty = 0;
          data.row.original.transfer_detail.forEach((element) => {
            qty += parseFloat(element.accepted) > 0 ? parseFloat(element.accepted) : 0;
          });
          return <span className="fw-semibold">{qty > 0 ? qty : 0}</span>;
        },
      },
      {
        Header: "Reject",
        filterable: true,
        Cell: (data) => {
          let qty = 0;
          data.row.original.transfer_detail.forEach((element) => {
            qty += parseFloat(element.rejected) > 0 ? parseFloat(element.rejected) : 0;
          });
          return <span className={qty > 0 ? "fw-semibold text-danger" : "fw-semibold"}>{qty}</span>;
        },
      },
      {
        Header: "Status",
        accessor: "transfer_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
            case "CONFIRMED":
              return <span className="badge text-uppercase badge-soft-secondary">{cell.value}</span>;
            case "SHIPPED":
              return <span className="badge text-uppercase badge-soft-primary">{cell.value}</span>;
            case "RECEIVED":
              return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
            case "COMPLETED":
              return <span className="badge text-uppercase badge-soft-success">{cell.value}</span>;
            default:
              return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
          }
        },
      },
    ],
    [transferList, handleTransferClick, userRole, userType, isCheckAll]
  );

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = transferList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setTransferList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => transferList, [transferList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        sortBy: [
          {
            id: "Tanggal",
            desc: true,
          },
        ],
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var status = statusTransfer.value ? statusTransfer.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      branchId: branchSelected?.value ?? "",
      type: "inbound-product",
    };
    dispatch(onGetTransfers(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setTransferList([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(onGetTransfers({ type: "Distribution", branchId: branchSelected?.value ?? "" }));
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (transfer && transfer.id) || 0,
      client: (transfer && transfer.client) || clientSelected,
      company: (transfer && transfer.company) || companySelected,
      branchId: (transfer && transfer.toBranchId) || 0,
      fromBranchId: (transfer && transfer.fromBranchId) || 0,
      toBranchId: (transfer && transfer.toBranchId) || 0,
      description: "",
      branch: (transfer && transfer.branch) ?? "",
      item: transferDetailItem,
    },
    validationSchema: Yup.object({
      company: Yup.object().required("Please enter company").nullable(true),
      client: Yup.object().required("Please enter company").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getProductInventoryLoading());
      const addSubmit = {
        transferId: values.id,
        clientId: values.company.value,
        statusId: 4,
        description: values.description,
        transaction_type: "Transfer",
        transaction_status: "IN",
        companyId: values.client.value,
        fromBranchId: values.fromBranchId,
        toBranchId: values.toBranchId,
        branchId: values.toBranchId,
        inv_detail: JSON.stringify(values.item),
        files: invDocImg.length > 0 ? invDocImg : [],
      };
      dispatch(onAddNewProductInventory(addSubmit));
      validation.resetForm();
      toggle();
    },
  });

  function handleTransferDetailAdd() {
    let arrTransferDetail = [];
    transferDetailItem.forEach((element) => {
      arrTransferDetail.push(element);
    });
    arrTransferDetail.push({
      detailId: 0,
      itemId: null,
      item: {
        label: "Select Product",
        value: null,
        name: "Select Product",
        sku: null,
        barcode: null,
        amount: 0,
        brandId: null,
        productId: null,
      },
      amount: 0,
      quantity: 0,
      uom: "",
      total: 0,
      name: "Select Product",
      sku: null,
      barcode: null,
      brandId: null,
      accepted: 0,
      rejected: 0,
    });
    setTransferDetailItem(arrTransferDetail);
  }

  const onClickDeleteDetailItem = (index) => {
    transferDetailItem.splice(index, 1);
  };

  useEffect(() => {
    if (branchSelected) {
      dispatch(resetTransferState());
      dispatch(onGetTransfers({ type: "Distribution", branchId: branchSelected?.value ?? "" }));
      handleGetProductVariant(companySelected.value);
    }
  }, [branchSelected]);

  document.title = "Penerimaan Distribusi Barang | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={transferList} />
      <Container fluid>
        <BreadCrumb title="Persediaan" pageTitle="Penerimaan Distribusi Barang">
          <div className="flex-shrink-0">
            <ExportDoc data={transferDoc} />
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={12}>
            <Card>
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    {isLoading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    )}
                  </h5>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-truck-line fs-15 me-1 align-bottom"></i> ALL INBOUND
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "SHIPPED");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> SHIPPED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "RECEIVED");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> RECEIVED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "COMPLETED");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> COMPLETED
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <Row>
                        <Col sm={1}>
                          <div className="me-2 mb-3 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={8}>
                          <div className="search-box me-2 mb-3 d-inline-block col-12">
                            <input
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                                gotoPage(0);
                              }}
                              placeholder={`${countSearch} Cari...`}
                              value={searchValue ?? ""}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={2}>
                          <div className="search-box me-2 mb-3 col-12">
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Pilih Tanggal"
                              options={{
                                mode: "range",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                setFilterDate(dateStr);
                              }}
                            />
                            <i className="bx bx-calendar-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={1}>
                          <div className="hstack gap-2">
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleFilter();
                              }}
                            >
                              <i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleResetFilter();
                              }}
                            >
                              <i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}
                        >
                          {" "}
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}
                        >
                          {" "}
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Penerimaan Barang" : "Penerimaan Barang"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <CardBody className="">
                        <Row className="g-3">
                          <Col lg={12} sm={12}>
                            <div className="mb-3">
                              <div className="input-group">
                                <span className="input-group-text">
                                  <i className="fs-20 ri-barcode-box-line"></i>
                                </span>
                                <Input name="transaction_reff" id="transaction_reff" className="fs-20 form-control" placeholder="Enter Barcode" type="text" value={validation.values.transaction_reff} onChange={validation.handleChange} onBlur={validation.handleBlur} invalid={validation.touched.transaction_reff && validation.errors.transaction_reff ? true : false} />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                      <CardBody className="border-top border-top-dashed">
                        <div>
                          <Table className="invoice-table table-borderless table-nowrap mb-0">
                            <thead className="align-middle">
                              <tr className="table-active">
                                <th scope="col" style={{ width: "20px" }}>
                                  #
                                </th>
                                <th scope="col" style={{ width: "520px" }}>
                                  Detail Produk
                                </th>
                                <th scope="col" className="text-center" style={{ width: "100px" }}>
                                  Quantity
                                </th>
                                <th scope="col" className="text-center" style={{ width: "100px" }}>
                                  Satuan
                                </th>
                                <th scope="col" className="text-start" colSpan={2}>
                                  Accepted
                                </th>
                                <th scope="col" className="text-start" colSpan={2}>
                                  Rejected
                                </th>
                              </tr>
                            </thead>
                            <tbody id="newlink">
                              {transferDetailItem.map((o, i) => {
                                return (
                                  <tr key={i} id={i} className="product">
                                    <th scope="row" className="product-id">
                                      {i + 1}
                                    </th>
                                    <td className="text-start vertical-align-center">
                                      <div>
                                        <Select
                                          name="item"
                                          value={transferDetailItem[i].item}
                                          isDisabled={true}
                                          placeholder="Select Product"
                                          onChange={(e) => {
                                            transferDetailItem[i].item = e;
                                            transferDetailItem[i].sku = e.sku;
                                            transferDetailItem[i].barcode = e.barcode;
                                            transferDetailItem[i].itemId = e.value;
                                            transferDetailItem[i].brandId = e.brandId;
                                            transferDetailItem[i].amount = parseFloat(e.price);
                                            transferDetailItem[i].quantity = 1;
                                            validation.setFieldValue("item", transferDetailItem);
                                          }}
                                          options={productList}
                                          validate={{ required: { value: true } }}
                                          invalid={validation.touched.item && validation.errors.item ? true : false}
                                        ></Select>
                                        {validation.touched.item && validation.errors.item ? (
                                          <p className="invalid-feedback d-block" type="invalid">
                                            {validation.errors.item}
                                          </p>
                                        ) : null}
                                      </div>
                                    </td>
                                    <td className="text-center vertical-align-center">
                                      <div className="mt-2">{transferDetailItem[i].uom}</div>
                                    </td>
                                    <td className="text-center vertical-align-center">
                                      <div className="mt-2">{transferDetailItem[i].quantity}</div>
                                    </td>
                                    <td className="text-end vertical-align-center">
                                      <div className="input-step ">
                                        <button
                                          type="button"
                                          className="minus bg-soft-success"
                                          onClick={() => {
                                            transferDetailItem[i].accepted = transferDetailItem[i].accepted > 0 ? transferDetailItem[i].accepted - 1 : transferDetailItem[i].accepted;
                                            validation.setFieldValue("item", transferDetailItem);
                                          }}
                                        >
                                          –
                                        </button>
                                        <Input
                                          name={`transferDetailItem.${i}.accepted`}
                                          onFocus={(e) => e.target.select()}
                                          placeholder="Qty"
                                          type="text"
                                          className=" product-accepted border-0"
                                          style={{ width: "80px" }}
                                          value={transferDetailItem[i].accepted}
                                          onChange={(e) => {
                                            if (!isNaN(parseFloat(e.target.value))) {
                                              transferDetailItem[i].accepted = e.target.value;
                                            } else {
                                              transferDetailItem[i].accepted = 0;
                                            }
                                            validation.setFieldValue("item", transferDetailItem);
                                          }}
                                          onBlur={validation.handleBlur}
                                        />
                                        <button
                                          type="button"
                                          className="plus bg-soft-success"
                                          onClick={() => {
                                            transferDetailItem[i].accepted = transferDetailItem[i].accepted + 1;
                                            validation.setFieldValue("item", transferDetailItem);
                                          }}
                                        >
                                          +
                                        </button>
                                      </div>
                                    </td>
                                    <td>
                                      <button
                                        type="button"
                                        className="btn btn btn-soft-success"
                                        onClick={() => {
                                          transferDetailItem[i].accepted = transferDetailItem[i].quantity;
                                          validation.setFieldValue("item", transferDetailItem);
                                        }}
                                      >
                                        All
                                      </button>
                                    </td>
                                    <td className="product-removal">
                                      <div className="input-step">
                                        <button
                                          type="button"
                                          className="minus bg-soft-warning"
                                          onClick={() => {
                                            transferDetailItem[i].rejected = transferDetailItem[i].rejected > 0 ? transferDetailItem[i].rejected - 1 : transferDetailItem[i].rejected;
                                            validation.setFieldValue("item", transferDetailItem);
                                          }}
                                        >
                                          –
                                        </button>
                                        <Input
                                          name={`transferDetailItem.${i}.rejected`}
                                          onFocus={(e) => e.target.select()}
                                          placeholder="Qty"
                                          type="text"
                                          className="product-rejected border-0"
                                          style={{ width: "80px" }}
                                          value={transferDetailItem[i].rejected}
                                          onChange={(e) => {
                                            if (!isNaN(parseFloat(e.target.value))) {
                                              transferDetailItem[i].rejected = e.target.value;
                                            } else {
                                              transferDetailItem[i].rejected = 0;
                                            }
                                            validation.setFieldValue("item", transferDetailItem);
                                          }}
                                          onBlur={validation.handleBlur}
                                        />
                                        <button
                                          type="button"
                                          className="plus bg-soft-warning"
                                          onClick={() => {
                                            transferDetailItem[i].rejected = transferDetailItem[i].rejected + 1;
                                            validation.setFieldValue("item", transferDetailItem);
                                          }}
                                        >
                                          +
                                        </button>
                                      </div>
                                    </td>
                                    <td>
                                      <button
                                        type="button"
                                        className="btn btn-soft-warning"
                                        onClick={() => {
                                          transferDetailItem[i].rejected = transferDetailItem[i].quantity;
                                          validation.setFieldValue("item", transferDetailItem);
                                        }}
                                      >
                                        All
                                      </button>
                                    </td>
                                    {transferDetailItem[i].isNewItem && (
                                      <td className="product-removal">
                                        <Link
                                          to="#"
                                          className="text-danger btn-icon btn btn-soft-danger flex-shrink-0"
                                          onClick={() => {
                                            onClickDeleteDetailItem(i);
                                            validation.setFieldValue("item", transferDetailItem);
                                          }}
                                        >
                                          <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                        </Link>
                                      </td>
                                    )}
                                  </tr>
                                );
                              })}
                            </tbody>
                            <tbody>
                              <tr className="d-none">
                                <td colSpan="7">
                                  <Link
                                    to="#"
                                    className="btn btn-soft-success fw-medium"
                                    id="add-item"
                                    onClick={() => {
                                      //handleTransferDetailAdd();
                                    }}
                                  >
                                    <i className="ri-add-fill me-1 align-bottom"></i>Add Item
                                  </Link>
                                </td>
                              </tr>
                              <tr className="border-top border-top-dashed mt-2">
                                <td colSpan="3">
                                  <div className="mb-3 d-flex justify-content-between">
                                    <Label htmlFor="education" className="form-label">
                                      Inbound Document
                                      {/* {educationLevelLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )} */}
                                    </Label>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-label btn-soft-success"
                                      onClick={() => {
                                        // setMediaType("other");
                                        toggleMedia();
                                      }}
                                    >
                                      <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                                    </button>
                                  </div>
                                  {invDocImg.map((f, i) => {
                                    if (f.isDeleted) {
                                      return null;
                                    } else {
                                      return (
                                        <div key={i} className="border-bottom mb-3">
                                          <div className="d-flex justify-content-between mb-3 align-items-center">
                                            <div className="me-2">
                                              <img src={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                            </div>

                                            <div className="text-truncate">{f.filename}</div>
                                            <div>
                                              <Link
                                                to="#"
                                                className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                                onClick={(e) => {
                                                  // e.stopPropagation();
                                                  handleDeleteFile(f);
                                                }}
                                              >
                                                <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                              </Link>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    }
                                  })}
                                  <div className="mb-3">
                                    <Label htmlFor="address-field" className="form-label">
                                      Keterangan
                                    </Label>
                                    <Input type="textarea" className="form-control" id="description" placeholder="Enter Inbound Description " name="description" rows={3} value={validation.values.description ?? ""} onBlur={validation.handleBlur} onChange={validation.handleChange} invalid={validation.touched.description && validation.errors.description ? true : false} />
                                    {validation.touched.description && validation.errors.description && (
                                      <small className="text-danger" type="invalid">
                                        {validation.errors.description}
                                      </small>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </CardBody>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Close
                        </button>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                          <span className="d-flex align-items-center">
                            {!!isEdit ? "Update Product Inbound" : "Add Product Inbound"}
                            {loading ? (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalDetail" isOpen={modalDetail} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    Invoice Detail
                  </ModalHeader>
                  {transfer !== undefined && transfer !== null ? (
                    <ModalBody>
                      <Row id="printThis">
                        <Col lg={12}>
                          <CardHeader className="border-bottom-dashed p-4">
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <img src={logoDark} className="card-logo card-logo-dark" alt="logo dark" height="40" />
                                <img src={logoLight} className="card-logo card-logo-light" alt="logo light" height="40" />
                                <div className="mt-sm-3 mt-3">
                                  <h6 className="text-uppercase fw-semibold">{transfer.client && transfer.client.label}</h6>
                                  <p className="mb-1">{transfer.company && transfer.company.label}</p>
                                </div>
                              </div>
                            </div>
                          </CardHeader>
                          <CardBody className="p-4">
                            <Row className="g-3">
                              <Col lg={4} xs={4}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">Invoice No</p>
                                <h5 className="fs-14 mb-0">
                                  #<span id="invoice-no">{transfer.transaction_no}</span>
                                </h5>
                              </Col>
                              <Col lg={4} xs={4}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">Date</p>
                                <h5 className="fs-14 mb-0">
                                  <span id="invoice-date">{handleValidDate(transfer.transactionat)}</span>
                                </h5>
                              </Col>
                              <Col lg={4} xs={4}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">Due Date</p>
                                <h5 className="fs-14 mb-0">
                                  <span id="invoice-date">{handleValidDate(transfer.dueat)}</span>
                                </h5>
                              </Col>
                            </Row>
                          </CardBody>
                          <CardBody className="p-4">
                            <div>
                              <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                                <thead>
                                  <tr className="table-active">
                                    <th scope="col" style={{ width: "50px" }}>
                                      #
                                    </th>
                                    <th scope="col">Detail Produk</th>
                                    <th scope="col">Quantity</th>
                                    <th scope="col">Satuan</th>
                                    <th scope="col">Accepted</th>
                                    <th scope="col">Rejected</th>
                                  </tr>
                                </thead>
                                <tbody id="products-list">
                                  {(transferDetailItem || []).map((o, i) => {
                                    return (
                                      <tr key={i} id={o.id} className="product">
                                        <th scope="row" className="product-id">
                                          {i + 1}
                                        </th>
                                        <td className="text-start">{o.name}</td>
                                        <td>{o.quantity}</td>
                                        <td>{o.uom}</td>
                                        <td>{o.accepted}</td>
                                        <td>{o.rejected}</td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </Table>
                            </div>
                            <div className="mt-4">
                              <div className="alert alert-info">
                                <p className="mb-0">
                                  <span className="fw-semibold">NOTES:</span>
                                  <span id="note"> {transfer.description}</span>
                                </p>
                              </div>
                            </div>
                            <div className="mt-4">
                              <div>
                                <p className="mb-0">{transfer.user}</p>
                              </div>
                            </div>
                          </CardBody>
                        </Col>
                      </Row>
                    </ModalBody>
                  ) : null}
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          toggleDetail();
                        }}
                      >
                        Tutup
                      </button>
                      <button
                        type="submit"
                        className="btn btn-info"
                        onClick={() => {
                          handlePrint();
                        }}
                      >
                        Print Document&nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
                      </button>
                    </div>
                  </div>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <PrintDoc innerRef={printRef} item={transfer} />
      </Container>
    </div>
  );
};

export default Transfer;
